module.exports = __webpack_public_path__ + "img/Sichtschutz_1.8be5794b.jpg";